import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import firebase from 'firebase';
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { URL, SUPERADMIN } from '../config';

type IState = {
  rooms: Array<string>,
};

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rooms: [],
    };
  }

  componentDidMount() {
    firebase
      .database()
      .ref(`users`)
      .orderByChild('uid')
      .equalTo(firebase.auth().currentUser.uid)
      .on('value', snapshots => {
        let admin = false;

        const users = snapshots.val();
        Object.keys(users).forEach((key, index) => {
          const user = users[key];
          if (user.lecturer) {
            const rooms = Object.keys(user.lecturer).filter(
              room => user.lecturer[room] === true,
            );
            this.setState({
              rooms,
            });
          }
        });
      });
  }

  handleSignOut(e) {
    firebase.auth().signOut();
  }

  render() {
    const page = `/${this.props.match.params.page || ''}`;
    const { room } = this.props;

    return (
      <Navbar collapseOnSelect staticTop>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to={URL.HOME}>
              <strong className='primary' style={{ color: '#0eb2ff' }}>
                #{room.toUpperCase()}
              </strong>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            {/*SUPERADMIN.indexOf(firebase.auth().currentUser.email) >= 0 && (
              <li className={page === URL.SUPERADMIN && 'active'}>
                <Link to={URL.SUPERADMIN}>Superadmin</Link>
              </li>
            )*/}
            <li className={page === URL.VOCABULARY && 'active'}>
              <Link to={URL.VOCABULARY}>Vocabulary</Link>
            </li>
            <li className={page === URL.PHRASES && 'active'}>
              <Link to={URL.PHRASES}>Phrases</Link>
            </li>
            <li className={page === URL.GRAMMAR && 'active'}>
              <Link to={URL.GRAMMAR}>Grammar</Link>
            </li>
            <li className={page === URL.USERS && 'active'}>
              <Link to={URL.USERS}>Students</Link>
            </li>
            <li className={page === URL.MESSAGES && 'active'}>
              <Link to={URL.MESSAGES}>Messages</Link>
            </li>
            <li className={page === URL.STATISTICS && 'active'}>
              <Link to={URL.STATISTICS}>Statistics</Link>
            </li>
          </Nav>
          <Nav pullRight>
            <li className={page === URL.NOTIFICATIONS && 'active'}>
              <Link to={URL.NOTIFICATIONS}>Notifications</Link>
            </li>
            <li className={page === URL.LESSONS && 'active'}>
              <Link to={URL.LESSONS}>Lessons</Link>
            </li>
            <li className={page === URL.TOPICS && 'active'}>
              <Link to={URL.TOPICS}>Topics</Link>
            </li>
            <NavDropdown
              title={`${firebase.auth().currentUser.email}`}
              id='basic-nav-dropdown'
            >
              {/*<li className={page === URL.SETTINGS && 'active'}>
                <Link to={URL.SETTINGS}>Settings</Link>
              </li>
              <MenuItem divider />
              */}
              {this.state.rooms.map(r => (
                <li className={room === r && 'active'}>
                  <a
                    href='#'
                    onClick={e => {
                      localStorage.setItem('room', r);
                      window.location = '/';
                    }}
                  >
                    #{r.toUpperCase()}
                  </a>
                </li>
              ))}
              <MenuItem divider />
              <MenuItem onClick={this.handleSignOut.bind(this)}>
                Logout
              </MenuItem>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js